import axios from "axios";

 const Axios = (method, url, update, token) =>{
  // '/officialWeb/getProductList'
  let option = {
    method: method,
    url: 'https://www.mi2x.com/md_back/' + url,             // 线上环境
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      // 'Authorization': `${API_KEY}`,
      // 'Content-Type': 'application/json;charset=UTF-8'
    }, 
    data: update
  }

  return axios(option)
  .then((res)=>{
    console.log(res)
    return res?.data
  })
  .catch((err)=>{
    console.log(err)
    if(err.response?.status === 524){
      alert('请求超时')
      return err
    }else if(err.response?.status === 504){
      alert('请求超时')
      return err
    }else{
      // alert('请求失败')
      console.log(JSON.stringify(err))
    }
  })
}

export default Axios